import React from 'react';
 
export default function Reviews(){
    var jamesMessage = "So far po sobrang ok un table... tahimik, sturdy and sobrang ganda ng table top..."
    return(
        <div style={{flexDirection:'grid'}}  >
          <div style={{width:'90%',height:0.1,backgroundColor:'#dcdde1',marginTop:200}} className="mr-auto ml-auto"/>
        <section>
          <div class="max-w-screen-xl px-4 py-16 mx-auto sm:px-6 lg:px-8">
          <div className='ml-50 mb-20'>
            {/* <p className="text-base leading-4 text-gray-600">Choose your table wisely</p> */}
            <h1 role="heading" className="md:text-5xl text-3xl font-extralight leading-10 mt-3 text-gray-800">
           What our clients say...
            </h1>
            </div>
            <div
              class="sm:gap-6 lg:gap-8 sm:columns-2 lg:columns-3 [column-fill:_balance]"
            >
              <div class="mb-8 sm:break-inside-avoid">
                <blockquote class="p-6 shadow bg-gray-50 rounded-xl  hover:bg-gray-200 ease-out duration-300 ">
                  <p class="leading-relaxed text-gray-700">
                    {jamesMessage}
                  </p>
                </blockquote>
        
                <div class="flex items-center gap-4 mt-4">
                  <img
                    src="https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairTheCaesar&accessoriesType=Blank&hairColor=BrownDark&facialHairType=Blank&clotheType=BlazerShirt&eyeType=Default&eyebrowType=Default&mouthType=Default&skinColor=Light"
                    class="object-cover w-12 h-12 rounded-full"
                    alt="Man"
                  />
        
                  <div class="text-sm">
                    <p class="font-medium">James ****</p>
                    <p class="mt-1">BPO Manager at Cavite PH</p>
                  </div>
                </div>
              </div>
        
              <div class="mb-8 sm:break-inside-avoid">
                <blockquote class="p-6 shadow bg-gray-50 rounded-xl  hover:bg-gray-200 ease-out duration-300  ">
                  <p class="leading-relaxed text-gray-700">
                    Thank you sir nacheck kona din ganda lahat di ko na tinanggal yung leg.
                  </p>
                </blockquote>
        
                <div class="flex items-center gap-4 mt-4">
                  <img
                    src="https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairFrizzle&accessoriesType=Blank&hairColor=BrownDark&facialHairType=Blank&clotheType=BlazerShirt&eyeType=Default&eyebrowType=Default&mouthType=Default&skinColor=Light"
                    class="object-cover w-12 h-12 rounded-full"
                    alt="Man"
                  />
        
                  <div class="text-sm">
                    <p class="font-medium">William ****</p>
                    <p class="mt-1">Business Owner at Pasig </p>
                  </div>
                </div>
              </div>
        
              <div class="mb-8 sm:break-inside-avoid">
                <blockquote class="p-6 shadow bg-gray-50 rounded-xl  hover:bg-gray-200 ease-out duration-300 ">
                  <p class="leading-relaxed text-gray-700">
                   Mam, Received! napo Ang ganda.
                  </p>
                </blockquote>
        
                <div class="flex items-center gap-4 mt-4">
                  <img
                    src="https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairShaggyMullet&accessoriesType=Blank&hairColor=BrownDark&facialHairType=Blank&clotheType=BlazerShirt&eyeType=Default&eyebrowType=Default&mouthType=Default&skinColor=Light"
                    class="object-cover w-12 h-12 rounded-full"
                    alt="Man"
                  />
        
                  <div class="text-sm">
                    <p class="font-medium">Bing ****</p>
                    <p class="mt-1">Software Engr at Makati City</p>
                  </div>
                </div>
              </div>
        
              <div class="mb-8 sm:break-inside-avoid">
                <blockquote class="p-6 shadow bg-gray-50 rounded-xl  hover:bg-gray-200 ease-out duration-300 ">
                  <p class="leading-relaxed text-gray-700">
                   Good price siya! solid wood at dual motor pa
                  </p>
                </blockquote>
        
                <div class="flex items-center gap-4 mt-4">
                  <img
                    src="https://avataaars.io/?avatarStyle=Transparent&topType=LongHairShaggyMullet&accessoriesType=Blank&hairColor=BrownDark&facialHairType=Blank&clotheType=BlazerShirt&eyeType=Default&eyebrowType=Default&mouthType=Default&skinColor=Dark"
                    class="object-cover w-12 h-12 rounded-full"
                    alt="Man"
                  />
        
                  <div class="text-sm">
                    <p class="font-medium">Carl ***</p>
                    <p class="mt-1">Business Owner at Quezon</p>
                  </div>
                </div>
              </div>
        
              {/* <div class="mb-8 sm:break-inside-avoid">
                <blockquote class="p-6 shadow bg-gray-50 rounded-xl">
                  <p class="leading-relaxed text-gray-700">
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Animi a
                    voluptatum quidem nulla quisquam natus velit provident earum esse,
                    odio numquam labore recusandae similique sunt.
                  </p>
                </blockquote>
        
                <div class="flex items-center gap-4 mt-4">
                  <img
                    src="https://www.hyperui.dev/photos/man-5.jpeg"
                    class="object-cover w-12 h-12 rounded-full"
                    alt="Man"
                  />
        
                  <div class="text-sm">
                    <p class="font-medium">Jeff Wezos</p>
                    <p class="mt-1">CEO of Shipping Company</p>
                  </div>
                </div>
              </div> */}
        
              {/* <div class="mb-8 sm:break-inside-avoid">
                <blockquote class="p-6 shadow bg-gray-50 rounded-xl">
                  <p class="leading-relaxed text-gray-700">
                    Lorem, ipsum dolor sit amet consectetur adipisicing elit. Eius ut
                    necessitatibus, repudiandae qui dolor minima.
                  </p>
                </blockquote>
        
                <div class="flex items-center gap-4 mt-4">
                  <img
                    src="https://www.hyperui.dev/photos/man-5.jpeg"
                    class="object-cover w-12 h-12 rounded-full"
                    alt="Man"
                  />
        
                  <div class="text-sm">
                    <p class="font-medium">Jeff Wezos</p>
                    <p class="mt-1">CEO of Shipping Company</p>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </section>  

        </div>)
}